module.exports = __webpack_public_path__ + "media/dorobek/assets/images/new_polon-0e3bab7984f2cfc9d6bf7e3687d5406c.png";